<template>
  <main class="depot">
    <div class="col-sm-8 mx-auto">
      <h1 class="display-2">Chargement</h1><hr>
      <form @submit.prevent="onSubmit">
        <div class="form-group">
          <label class="">Montant</label>
          <div class="input-group">
            <input type="number" class="form-control" value="12345555" v-model="payload.amount"/>
            <div class="input-group-prepend">
              <select class="custom-select mr-sm-2" v-model="rate">
                <option v-for="f in flux" :key="f.id" :value="f.value">{{f.key}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="">Equivalence</label>
          <div class="input-group">
          <input type="text" class="form-control" :value="rate*payload.amount" disabled/>
          <div class="input-group-prepend">
            <select class="custom-select mr-sm-2" disabled>
              <option value="1">Ross</option>
            </select>
          </div>
          </div>
        </div>
        <!--div class="form-group">
          <label class="">Taux</label>
          <input type="text" class="form-control" disabled='disabled' value="3%">
        </div>
        <div class="form-group">
          <label class="">Total</label>
          <input type="text" class="form-control" disabled='disabled' :value="0.97*payload.amount">
        </div>
        <div class="form-group">
          <label class="">Balance</label>
          <input type="text" class="form-control" disabled='disabled' :value="$store.getters.loggedAs.solde">
        </div-->
        <div class="form-group">
          <div class="form-check form-check-inline" v-for="(tier, index) in tiers" :key="index">
            <input class="form-check-input" type="radio" :value="tier" v-model="payload.tierp"/>
            <img :src="path(tier)" alt="" class="img-fluid">
          </div>
        </div>
        <div class="form-group">
          <label class="">Référence de validation</label>
          <input type="text" class="form-control" v-model="payload.validRef"/>
        </div>
        <div class="form-group">
          <button type="submit" :class="[{ 'disabled': loading }, 'btn btn-warning btn-lg']">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading"></span>
            Valider
          </button>
        </div>
      </form>
    </div>
  </main>
</template>

<script>

export default {
  name: 'depot',
  data() {
    return {loading: false, payload: {type: 'depot', amount: 0}, rate: 10, flux: [{id: 1, key: 'XOF', value: 10},{id: 2, key: 'EUR', value: 0},{id: 3, key: 'USD', value: 0},]}
  },
  computed: {
    tiers() {
      return this.$store.getters['resource/TIERS']
    }
  },
  methods: {
    path(v) {
      return require(`../../assets/img/${v.type==='PayPal' ? 'paypal': v.type==='VisArd' ? 'visa': 'mastercard'}.png`);
    },
    onSubmit() { 
      this.loading = true;
      this.$store.dispatch('transact/insertTrans', this.payload).then(
        () => {
          this.payload = {type: 'depot', amount: 0}; 
          this.loading = false
        }
      )
    }
  },
}
</script>

<style scoped lang="scss">

</style>
